// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
	navLogo: 'home-nav-logo',
	navReservationButton: 'home-nav-reservation-button',
	navPhoneLink: 'home-nav-phone-link',
	heroSection: 'home-hero-section',
	heroTitle: 'home-hero-title',
	heroReservationButton: 'home-hero-reservation-button',
	heroHallsButton: 'home-hero-halls-button',
	hallsSection: 'home-halls-section',
	hallCard: (id) => `home-hall-card-${id}`,
	orgsSection: 'home-orgs-section',
	cateringSection: 'home-catering-section',
	heritageSection: 'home-heritage-section',
	reservationSection: 'home-reservation-section',
	reservationForm: 'home-reservation-form',
	reservationNameInput: 'home-reservation-name-input',
	reservationHallSelect: 'home-reservation-hall-select',
	reservationPhoneInput: 'home-reservation-phone-input',
	reservationDateInput: 'home-reservation-date-input',
	reservationRequestsInput: 'home-reservation-requests-input',
	reservationEmailInput: 'home-reservation-email-input',
	reservationKvkkCheckbox: 'home-reservation-kvkk-checkbox',
	reservationSubmitButton: 'home-reservation-submit-button',
	reservationSuccess: 'home-reservation-success',
	contactSection: 'home-contact-section',
	floatingWhatsappButton: 'home-floating-whatsapp-button',
	footerSection: 'home-footer-section',
};
